import { NavLink, Outlet, Link } from "react-router-dom";
import { Home, Compass, CreditCard, CalendarPlus, Activity, FileText, UserRound } from "lucide-react";
import { Logo } from "@/components/common";
import { useAuth } from "@/context/AuthContext";

const TABS = [
  { to: "/app", label: "Home", icon: Home, end: true },
  { to: "/app/explore", label: "Explore", icon: Compass },
  { to: "/app/cards", label: "Cards", icon: CreditCard },
  { to: "/app/book", label: "Book", icon: CalendarPlus },
  { to: "/app/activity", label: "Activity", icon: Activity },
  { to: "/app/records", label: "Records", icon: FileText },
];

export default function CustomerLayout() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-slate-100/60">
      <div className="relative mx-auto min-h-screen max-w-md bg-white pb-28 shadow-2xl shadow-slate-300/40 sm:border-x sm:border-slate-200/60">
        <header className="sticky top-0 z-30 flex items-center justify-between bg-white/85 px-5 py-3 backdrop-blur-xl">
          <Link to="/app" className="flex items-center gap-2" data-testid="customer-header-home">
            <Logo size={34} />
            <span className="text-base font-extrabold text-gradient">GIA CARE+</span>
          </Link>
          <Link to="/app/profile" className="flex h-9 w-9 items-center justify-center rounded-full bg-purple-50 text-sm font-bold text-purple-700 ring-1 ring-purple-100" data-testid="customer-nav-profile">
            {user?.full_name?.[0] || <UserRound size={16} />}
          </Link>
        </header>
        <main className="px-5 pt-2"><Outlet /></main>
        <nav className="fixed bottom-0 left-1/2 z-40 w-full max-w-md -translate-x-1/2 border-t border-slate-200/70 bg-white/90 px-2 pt-2 backdrop-blur-xl pb-safe" data-testid="customer-bottom-nav">
          <div className="grid grid-cols-6 pb-2">
            {TABS.map(({ to, label, icon: Icon, end }) => (
              <NavLink key={to} to={to} end={end} data-testid={`customer-nav-${label.toLowerCase()}`}
                className={({ isActive }) => `flex flex-col items-center gap-1 rounded-xl py-1.5 text-[10px] font-semibold transition-colors ${isActive ? "text-purple-700" : "text-slate-400 hover:text-slate-700"}`}>
                {({ isActive }) => (
                  <>
                    <span className={`flex h-8 w-12 items-center justify-center rounded-full transition-colors ${isActive ? "bg-purple-100" : ""}`}><Icon size={19} /></span>
                    {label}
                  </>
                )}
              </NavLink>
            ))}
          </div>
        </nav>
      </div>
    </div>
  );
}
